import { mutate } from 'swr';
import useSWRMutationBase from 'swr/mutation';

import { FetcherParams, fetcher } from '@/data/fetcher';
import { useStoredOrganizationId } from '@/hooks/useStoredOrganizationId';
import { matchKeyPartial, useOrganizationId } from '@/hooks/useSwr';
import { HostListenerCreateBody, HostListenerSchema } from '@/types/schema';
import { hostApiListenersPath } from '@/utils/constants';

export const useHostCreateListenerMutation = () => {
  const organizationId = useOrganizationId();
  const { orgId } = useStoredOrganizationId();
  return useSWRMutationBase<
    HostListenerSchema,
    Error,
    FetcherParams<never, never>,
    HostListenerCreateBody
  >(
    {
      method: 'POST',
      url: hostApiListenersPath,
      headers: { 'X-Tenant-Id': organizationId, 'X-Organization-Id': orgId },
    },
    (key, { arg }) => fetcher({ ...key, json: arg }),
    {
      onSuccess: () => mutate(matchKeyPartial({ url: hostApiListenersPath })),
    }
  );
};
